import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../storageService/offlineService";
import { OfflineSyncService } from "../storageService/offlineSyncService";

const LoadCoachDetails = (defaultSite, date, personId) => {
    const offlineService = new OfflineService();

    HttpService.post('/TeamCoach/GetIntegratedSystem', {
        GeoLocationId: defaultSite.id
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }
        else {
            offlineService.removeOfflineBySite(defaultSite.id, "IntegratedSystem");
            offlineService.addOffline(defaultSite.id, "IntegratedSystem", result);
        }

        if (result.data.TeamCoachId !== null && parseInt(result.data.TeamCoachId) > 0) {
            LoadCoachOfflineDetails(defaultSite.id, personId, result.data.TeamCoachId);
        }
    },
    (error) => {
        console.log(error);
    });
};

const LoadCoachOfflineDetails = (siteId, personId, coachId) => {
    const offlineService = new OfflineService();

    HttpService.post('/TeamCoach/GetAppFunctionalAreas', { PplPersonId: personId })
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }
            else {
                offlineService.removeOfflineBySite(siteId, "AppFunctionalAreas");
                offlineService.addOffline(siteId, "AppFunctionalAreas", result);
            }
        },
            (error) => {
                console.log(error);
            });

    HttpService.post('/TeamCoach/GetAllSurveyTypes', {})
        .then(async (result) => {
            if (result && (result.error || result.offline)) {
                return;
            }
            else {
                offlineService.removeOfflineBySite(siteId, "SurveyTypes");
                offlineService.addOffline(siteId, "SurveyTypes", result);
            }
        },
            (error) => {
                console.log(error);
            });

    HttpService.post('/TeamCoach/GetApiHirnodesOffline', { TeamCoachId: coachId })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }
        else {
            offlineService.removeOfflineBySite(siteId, "AllHirNodes");
            offlineService.addOffline(siteId, "AllHirNodes", result);
        }
    },
    (error) => {
        console.log(error);
    });

    HttpService.post('/TeamCoach/GetTeamCoachQueueOffline', {
        GeoLocationId: siteId.toString(),
        TeamCoachId: coachId
    })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }
        else {
            offlineService.removeOfflineBySite(siteId, "TeamCoachQueue");
            offlineService.addOffline(siteId, "TeamCoachQueue", result);
        }
    },
    (error) => {
        console.log(error);
    });

    HttpService.post('/TeamCoach/GetTemplateOffline', { TeamCoachId: coachId })
    .then(async (result) => {
        if (result && (result.error || result.offline)) {
            return;
        }
        else {
            offlineService.removeOfflineBySite(siteId, "AllSurveyTemplates");
            offlineService.addOffline(siteId, "AllSurveyTemplates", result);
        }
    },
    (error) => {
        console.log(error);
    });
};

const SaveTeamCoachOfflineData = async (siteId, entityId, keyName, param, item, url, isOnline, remove) => {
    const offlineSyncService = new OfflineSyncService();
    let id = -1;
    let pId = -1;
    let exists = [];

    if ((entityId + "").substr(0, 1) === "$") {
        pId = parseInt(entityId.substr(1, entityId.length - 1));
        exists = await offlineSyncService.getByNameAndId(pId, keyName);
    }
    else if (entityId > 0) {
        pId = entityId;
        exists = await offlineSyncService.getByNameAndEntityId(pId, keyName);
    }

    if (!isOnline) {
        if (remove && ((entityId + "").substr(0, 1) === "$")) {
            offlineSyncService.removeById(exists.Id);
        }
        else if (entityId === 0 || !exists) {
            id = await offlineSyncService.add(siteId, pId, url, keyName, param);
        }
        else {
            offlineSyncService.updateById(exists.Id, param);
            id = exists.Id;
        }
    }

    if (item !== null) {
        UpdateOfflineData(siteId, item, remove);
    }
    
    return id;
};

const UpdateOfflineData = async (siteId, item, remove) => {
    const offlineService = new OfflineService();
    const offlineResult = await offlineService.getOfflinesBySite(siteId, "TeamCoachQueue");
    const data = offlineResult.OfflineData.data;
    const index = data.findIndex(d => d.svyGeneratedSurveyId === item.svyGeneratedSurveyId);

    if (remove) {
        offlineResult.OfflineData.data.splice(index, 1);
    }
    else if (index === -1)
        offlineResult.OfflineData.data.push(item);
    else {
        offlineResult.OfflineData.data[index] = item;
    }

    offlineService.updateOfflineByName(siteId, "TeamCoachQueue", offlineResult.OfflineData);
};

export { LoadCoachDetails, SaveTeamCoachOfflineData };
